/*
 * Created by: cparaschiv
 * Date: 24.04.2014, 10:09 
 */

TS.ns('TS.data');

// TODO: notify grids when items are being added / removed from observable array
// TODO: remove the 'dataChanged' event fired by BindingList
(function($, undefined) {
    'use strict';

    var CHANGE = "change",
        unwrap = TS.unwrap;

    function assignIds(data) {
        if(data) {
            $.each(data, function (idx, item) {
                item["uid"] = unwrap(item["UID"]);
            });
        }
    }

    function plainData(data) {
        var ret = ko.mapping.toJS(data);
        assignIds(ret);
        return ret;
    }

    /**
     * @class TS.data.KoGridSource
     * @classdesc
     * Datasource for Kendo grid that cand accomodate Knockout observables.
     */
    TS.data.KoGridSource = kendo.data.DataSource.extend(
        /** @lends TS.data.KoGridSource# */
        {

        Extends: kendo.data.DataSource,

        isLoaded: false,
        _observableCollection: null,
        _initialData: null,
        _koSubscriptions: null,
        _changes: [],

        init: function (options) {
            var me = this;

            me.__id = TS.newUID();
            me._koSubscriptions = [];

            kendo.data.DataSource.fn.init.call(me, options);

            me.data(options.localData);
        },

        data: function(value) {
            var me = this,
                plain;
            if (value !== undefined) {

                me._data = value;
                me._initialData = value;
                me._subscribe();
                assignIds(unwrap(value));

                plain = plainData(me._data);
                plain && (me._total = plain.length);
                me._process(plain);
            } else {
                return me._data;
            }
        },

        /**
         * Gets the record with the specified uid.
         * @param {Number} id
         * @returns {*}
         */
        getByUid: function (id) {
            var idx, length,
                data = this._flatData(this._data),
                arr;

            if (!data) {
                return;
            }

            arr = unwrap(data);

            for (idx = 0, length = arr.length; idx < length; idx++) {
                if (arr[idx].uid == id) {
                    return arr[idx];
                }
            }
        },

        /**
         * Gets the index of the record with the specified uid.
         * @param {Number} id
         * @returns {*}
         */
        indexFor: function(id) {
            var idx = -1;

            $.each(unwrap(this._data), function(i, rec) {
                if (rec.uid == id) {
                    idx = i;
                    return false;
                }
            });

            return idx;
        },

        read: function (data) {
            var me = this;

            me.success(me._data);
        },

        query: function (options) {
            var me = this,
                result;

            result = kendo.data.Query.process(plainData(me._data), me._mergeState(options));

            if (!me.options.serverFiltering) {
                if (result.total !== undefined) {
                    me._total = result.total;
                } else {
                    me._total = TS.unwrap(me._data).length;
                }
            }

            me._view = result.data;
            //TODO: aggregate result
            //that._aggregateResult = calculateAggregates(that._data, options);
            me.trigger(CHANGE, { items: result.data });
        },

        fetch: function (callback) {
            var me = this;

            me.read();
            me.trigger(CHANGE);
        },

        success: function (data) {
            var me = this,
                options = me.options,
                plain;

            plain = plainData(me._data);
            me._process(plain);
        },

        _unsubscribe: function() {
            var me = this,
                i, len;

            for(i=0, len = me._koSubscriptions.length; i<len; i++) {
                me._koSubscriptions[i].dispose();
            }
            me._koSubscriptions.length = 0;
        },

        _subscribe: function() {
            var me = this,
                data,
                sub;

            me._unsubscribe();

            data = unwrap(me._data);
            if(data) {
                me._total = data.length;

                $.each(data, function (i, record) {
                    record.__id = TS.newUID();
                    $.each(record, function (key, obs) {
                        if (TS.isObservable(obs)) {
                            sub = obs.subscribe(function (newVal) {
                                var idx = TS.Util.findIndex(me._view, unwrap(record.uid), 'uid'),
                                    viewItem = idx > -1 ? me._view[idx] : null;

                                if (viewItem) {
                                    viewItem[key] = newVal;
                                }
                                me.trigger(CHANGE, {action: "itemchange", items: me._changes});
                            });

                            sub._debugInfo = 'gridSource.subscribe';
                            me._koSubscriptions.push(sub);
                        }
                    })
                });
            }
        }
    });

})(jQuery);